'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'bath';
var width = 512;
var height = 512;
var aliases = [128705,"bathtub"];
var unicode = 'f2cd';
var svgPathData = 'M64 0l-32 0 0 256-32 0 0 64 32 0 0 48c0 28.4 12.4 54 32 71.6l0 72.4 64 0 0-48 256 0 0 48 64 0 0-72.4c19.6-17.6 32-43.1 32-71.6l0-48 32 0 0-64-416 0 0-192 18.7 0 18.8 18.8c-3.6 9.1-5.5 18.9-5.5 29.2 0 19.6 7 37.5 18.7 51.4l-12.6 12.6 33.9 33.9 17-17 104-104 17-17-33.9-33.9-12.6 12.6C245.5 39 227.6 32 208 32 197.7 32 187.8 34 178.8 37.5 156.9 15.6 144.4 3.1 141.3 0L64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBath = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;